export const MINIMUM_CHARGES = {
	usd: 0.5,
	aed: 2.0,
	aud: 0.5,
	bgn: 1.0,
	brl: 0.5,
	cad: 0.5,
	chf: 0.5,
	czk: 15.0,
	dkk: 2.5,
	eur: 0.5,
	gbp: 0.3,
	hkd: 4.0,
	huf: 175.0,
	inr: 0.5,
	jpy: 50,
	mxn: 10,
	myr: 2,
	nok: 3.0,
	nzd: 0.5,
	pln: 2.0,
	ron: 2.0,
	sek: 3.0,
	sgd: 0.5
};

export const ZERO_DECIMAL_CURRENCIES = [
	"bif",
	"clp",
	"djf",
	"gnf",
	"jpy",
	"kmf",
	"krw",
	"mga",
	"pyg",
	"rwf",
	"ugx",
	"vnd",
	"vuv",
	"xaf",
	"xof",
	"xpf"
];

export const CURRENCY_RATES = {
	aed: 3.6729511553526604,
	afn: 79.03781664267272,
	all: 102.77814766705946,
	amd: 512.6039817394734,
	ang: 1.7968579231540363,
	aoa: 648.0000979857645,
	ars: 95.48771869878256,
	aud: 1.3175006762692716,
	awg: 1.8005001461411614,
	azn: 1.6963756154469114,
	bam: 1.6392842516776922,
	bbd: 2.0214739571425344,
	bdt: 84.89239823089633,
	bgn: 1.6378881639058969,
	bif: 1981.5360432678335,
	bmd: 1.0,
	bnd: 1.3444693735862203,
	bob: 6.902943006621996,
	brl: 4.914703810808751,
	bsd: 1.0011816915692882,
	bwp: 10.880706100493194,
	bzd: 2.018037755506256,
	cad: 1.2307506128297703,
	cdf: 1997.0002093712917,
	chf: 0.9170228072335269,
	clp: 734.0001817342811,
	cny: 6.45490268003628,
	cop: 3766.2507464086543,
	crc: 620.3420892407444,
	cve: 92.42008925916899,
	czk: 21.328254823286443,
	djf: 178.2347035428135,
	dkk: 6.22770216682537,
	dop: 57.02540762496744,
	dzd: 134.0099920355161,
	egp: 15.67110115062087,
	etb: 43.8535833059057,
	eur: 0.8374851660439965,
	fjd: 2.0581030458498004,
	fkp: 0.7088432571138084,
	gbp: 0.7190555512285489,
	gel: 3.1350285708064396,
	gip: 0.7088432571138084,
	gmd: 51.10982110479368,
	gnf: 9835.222508083825,
	gtq: 7.754017206970222,
	gyd: 209.34544420631948,
	hkd: 7.761651721743879,
	hnl: 23.9602764036042,
	hrk: 6.280202436914337,
	htg: 93.60664326733114,
	huf: 294.8299126251726,
	idr: 14431.202861519314,
	ils: 3.247850384950057,
	// inr: 74.21091477667201,
	inr: 81.01,
	isk: 123.03045431057804,
	jmd: 149.97739962530915,
	jpy: 110.78502342027268,
	kes: 107.7499411666671,
	kgs: 84.66251609018376,
	khr: 4083.6142233455694,
	kmf: 412.5501599177925,
	krw: 1127.0552019972347,
	kyd: 0.8343043973833614,
	kzt: 428.34161857408105,
	lak: 9485.879007680578,
	lbp: 1513.9555429374457,
	lkr: 199.48054815079087,
	lrd: 171.34981085397524,
	lsl: 14.220139675775995,
	mad: 8.897160171550462,
	mdl: 18.03586027732484,
	mga: 3775.8398435242716,
	mkd: 51.65117067863935,
	mmk: 1647.683293259668,
	mnt: 2845.998838408075,
	mop: 8.006539084176472,
	mro: 356.99989866429496,
	mur: 41.34982006631208,
	mvr: 15.459726594592693,
	mwk: 802.2695914998607,
	mxn: 19.8217027580899,
	myr: 4.156031023800491,
	mzn: 63.27501589128103,
	nad: 14.220054252289057,
	ngn: 410.75008437663047,
	nio: 34.96493030867191,
	nok: 8.488198577782692,
	npr: 118.74698484403095,
	nzd: 1.4147502912354666,
	pab: 1.0011733167176275,
	pen: 3.984159805569444,
	pgk: 3.5318625418847267,
	php: 48.50050960972354,
	pkr: 157.96139695875638,
	pln: 3.7787506563789988,
	pyg: 6789.346659397295,
	qar: 3.6409843465647618,
	ron: 4.125500502072358,
	rsd: 98.55420580862962,
	rub: 72.16981602963358,
	rwf: 1006.746480677961,
	sar: 3.7502359614455334,
	sbd: 8.022496526530274,
	scr: 14.77452889365697,
	sek: 8.466871180544215,
	sgd: 1.3417810462032191,
	shp: 0.7088432571138084,
	sll: 10260.001972277565,
	sos: 585.0004237674941,
	srd: 20.728504896357023,
	std: 20408.500172940687,
	szl: 14.228035485921456,
	thb: 31.79711168115935,
	tjs: 11.418072594889162,
	top: 2.2434502378876613,
	try: 8.680962538451038,
	ttd: 6.809881654971187,
	twd: 27.907507300776935,
	tzs: 2319.0000318244365,
	uah: 27.557600136007594,
	ugx: 3559.093310084745,
	usd: 1.0,
	uyu: 43.65016402146977,
	uzs: 10577.095383698015,
	vnd: 23025.00456513164,
	vuv: 108.44082539188025,
	wst: 2.5219735170440796,
	xaf: 549.7231341039873,
	xcd: 2.702550393576154,
	xof: 549.7968554106985,
	xpf: 100.1992913200525,
	yer: 250.22502305177917,
	zar: 14.106773496274448,
	zmw: 22.611123812969463
};
export const SUPPORTED_CURRENCIES = [
	"usd",
	"aed",
	"afn",
	"all",
	"amd",
	"ang",
	"aoa",
	"ars",
	"aud",
	"awg",
	"azn",
	"bam",
	"bbd",
	"bdt",
	"bgn",
	"bif",
	"bmd",
	"bnd",
	"bob",
	"brl",
	"bsd",
	"bwp",
	"bzd",
	"cad",
	"cdf",
	"chf",
	"clp",
	"cny",
	"cop",
	"crc",
	"cve",
	"czk",
	"djf",
	"dkk",
	"dop",
	"dzd",
	"egp",
	"etb",
	"eur",
	"fjd",
	"fkp",
	"gbp",
	"gel",
	"gip",
	"gmd",
	"gnf",
	"gtq",
	"gyd",
	"hkd",
	"hnl",
	"hrk",
	"htg",
	"huf",
	"idr",
	"ils",
	"inr",
	"isk",
	"jmd",
	"jpy",
	"kes",
	"kgs",
	"khr",
	"kmf",
	"krw",
	"kyd",
	"kzt",
	"lak",
	"lbp",
	"lkr",
	"lrd",
	"lsl",
	"mad",
	"mdl",
	"mga",
	"mkd",
	"mmk",
	"mnt",
	"mop",
	"mro",
	"mur",
	"mvr",
	"mwk",
	"mxn",
	"myr",
	"mzn",
	"nad",
	"ngn",
	"nio",
	"nok",
	"npr",
	"nzd",
	"pab",
	"pen",
	"pgk",
	"php",
	"pkr",
	"pln",
	"pyg",
	"qar",
	"ron",
	"rsd",
	"rub",
	"rwf",
	"sar",
	"sbd",
	"scr",
	"sek",
	"sgd",
	"shp",
	"sll",
	"sos",
	"srd",
	"std",
	"szl",
	"thb",
	"tjs",
	"top",
	"try",
	"ttd",
	"twd",
	"tzs",
	"uah",
	"ugx",
	"uyu",
	"uzs",
	"vnd",
	"vuv",
	"wst",
	"xaf",
	"xcd",
	"xof",
	"xpf",
	"yer",
	"zar",
	"zmw"
];

export const CURRENCY_CODES = [
	{ label: "Andorra", value: { "countryCode:": "ad", currencyCode: "eur" } },
	{
		label: "United Arab Emirates",
		value: { "countryCode:": "ae", currencyCode: "aed" }
	},
	{
		label: "Afghanistan",
		value: { "countryCode:": "af", currencyCode: "afn" }
	},
	{
		label: "Antigua and Barbuda",
		value: { "countryCode:": "ag", currencyCode: "xcd" }
	},
	{ label: "Anguilla", value: { "countryCode:": "ai", currencyCode: "xcd" } },
	{ label: "Albania", value: { "countryCode:": "al", currencyCode: "all" } },
	{ label: "Armenia", value: { "countryCode:": "am", currencyCode: "amd" } },
	{ label: "Angola", value: { "countryCode:": "ao", currencyCode: "aoa" } },
	{
		label: "Argentina",
		value: { "countryCode:": "ar", currencyCode: "ars" }
	},
	{
		label: "American Samoa",
		value: { "countryCode:": "as", currencyCode: "usd" }
	},
	{ label: "Austria", value: { "countryCode:": "at", currencyCode: "eur" } },
	{
		label: "Australia",
		value: { "countryCode:": "au", currencyCode: "aud" }
	},
	{ label: "Aruba", value: { "countryCode:": "aw", currencyCode: "awg" } },
	{ label: "Åland", value: { "countryCode:": "ax", currencyCode: "eur" } },
	{
		label: "Azerbaijan",
		value: { "countryCode:": "az", currencyCode: "azn" }
	},
	{
		label: "Bosnia and Herzegovina",
		value: { "countryCode:": "ba", currencyCode: "bam" }
	},
	{ label: "Barbados", value: { "countryCode:": "bb", currencyCode: "bbd" } },
	{
		label: "Bangladesh",
		value: { "countryCode:": "bd", currencyCode: "bdt" }
	},
	{ label: "Belgium", value: { "countryCode:": "be", currencyCode: "eur" } },
	{
		label: "Burkina Faso",
		value: { "countryCode:": "bf", currencyCode: "xof" }
	},
	{ label: "Bulgaria", value: { "countryCode:": "bg", currencyCode: "bgn" } },
	{ label: "Bahrain", value: { "countryCode:": "bh", currencyCode: "bhd" } },
	{ label: "Burundi", value: { "countryCode:": "bi", currencyCode: "bif" } },
	{ label: "Benin", value: { "countryCode:": "bj", currencyCode: "xof" } },
	{
		label: "Saint Barthélemy",
		value: { "countryCode:": "bl", currencyCode: "eur" }
	},
	{ label: "Bermuda", value: { "countryCode:": "bm", currencyCode: "bmd" } },
	{ label: "Brunei", value: { "countryCode:": "bn", currencyCode: "bnd" } },
	{ label: "Bolivia", value: { "countryCode:": "bo", currencyCode: "bob" } },
	{ label: "Bonaire", value: { "countryCode:": "bq", currencyCode: "usd" } },
	{ label: "Brazil", value: { "countryCode:": "br", currencyCode: "brl" } },
	{ label: "Bahamas", value: { "countryCode:": "bs", currencyCode: "bsd" } },
	{ label: "Bhutan", value: { "countryCode:": "bt", currencyCode: "btn" } },
	{
		label: "Bouvet Island",
		value: { "countryCode:": "bv", currencyCode: "nok" }
	},
	{ label: "Botswana", value: { "countryCode:": "bw", currencyCode: "bwp" } },
	{ label: "Belarus", value: { "countryCode:": "by", currencyCode: "byr" } },
	{ label: "Belize", value: { "countryCode:": "bz", currencyCode: "bzd" } },
	{ label: "Canada", value: { "countryCode:": "ca", currencyCode: "cad" } },
	{
		label: "Cocos [Keeling] Islands",
		value: { "countryCode:": "cc", currencyCode: "aud" }
	},
	{
		label: "Democratic Republic of the Congo",
		value: { "countryCode:": "cd", currencyCode: "cdf" }
	},
	{
		label: "Central African Republic",
		value: { "countryCode:": "cf", currencyCode: "xaf" }
	},
	{
		label: "Republic of the Congo",
		value: { "countryCode:": "cg", currencyCode: "xaf" }
	},
	{
		label: "Switzerland",
		value: { "countryCode:": "ch", currencyCode: "chf" }
	},
	{
		label: "Ivory Coast",
		value: { "countryCode:": "ci", currencyCode: "xof" }
	},
	{
		label: "Cook Islands",
		value: { "countryCode:": "ck", currencyCode: "nzd" }
	},
	{ label: "Chile", value: { "countryCode:": "cl", currencyCode: "clp" } },
	{ label: "Cameroon", value: { "countryCode:": "cm", currencyCode: "xaf" } },
	{ label: "China", value: { "countryCode:": "cn", currencyCode: "cny" } },
	{ label: "Colombia", value: { "countryCode:": "co", currencyCode: "cop" } },
	{
		label: "Costa Rica",
		value: { "countryCode:": "cr", currencyCode: "crc" }
	},
	{ label: "Cuba", value: { "countryCode:": "cu", currencyCode: "cup" } },
	{
		label: "Cape Verde",
		value: { "countryCode:": "cv", currencyCode: "cve" }
	},
	{ label: "Curacao", value: { "countryCode:": "cw", currencyCode: "ang" } },
	{
		label: "Christmas Island",
		value: { "countryCode:": "cx", currencyCode: "aud" }
	},
	{ label: "Cyprus", value: { "countryCode:": "cy", currencyCode: "eur" } },
	{ label: "Czechia", value: { "countryCode:": "cz", currencyCode: "czk" } },
	{ label: "Germany", value: { "countryCode:": "de", currencyCode: "eur" } },
	{ label: "Djibouti", value: { "countryCode:": "dj", currencyCode: "djf" } },
	{ label: "Denmark", value: { "countryCode:": "dk", currencyCode: "dkk" } },
	{ label: "Dominica", value: { "countryCode:": "dm", currencyCode: "xcd" } },
	{
		label: "Dominican Republic",
		value: { "countryCode:": "do", currencyCode: "dop" }
	},
	{ label: "Algeria", value: { "countryCode:": "dz", currencyCode: "dzd" } },
	{ label: "Ecuador", value: { "countryCode:": "ec", currencyCode: "usd" } },
	{ label: "Estonia", value: { "countryCode:": "ee", currencyCode: "eur" } },
	{ label: "Egypt", value: { "countryCode:": "eg", currencyCode: "egp" } },
	{
		label: "Western Sahara",
		value: { "countryCode:": "eh", currencyCode: "mad" }
	},
	{ label: "Eritrea", value: { "countryCode:": "er", currencyCode: "ern" } },
	{ label: "Spain", value: { "countryCode:": "es", currencyCode: "eur" } },
	{ label: "Ethiopia", value: { "countryCode:": "et", currencyCode: "etb" } },
	{ label: "Finland", value: { "countryCode:": "fi", currencyCode: "eur" } },
	{ label: "Fiji", value: { "countryCode:": "fj", currencyCode: "fjd" } },
	{
		label: "Falkland Islands",
		value: { "countryCode:": "fk", currencyCode: "fkp" }
	},
	{
		label: "Micronesia",
		value: { "countryCode:": "fm", currencyCode: "usd" }
	},
	{
		label: "Faroe Islands",
		value: { "countryCode:": "fo", currencyCode: "dkk" }
	},
	{ label: "France", value: { "countryCode:": "fr", currencyCode: "eur" } },
	{ label: "Gabon", value: { "countryCode:": "ga", currencyCode: "xaf" } },
	{
		label: "United Kingdom",
		value: { "countryCode:": "gb", currencyCode: "gbp" }
	},
	{ label: "Grenada", value: { "countryCode:": "gd", currencyCode: "xcd" } },
	{ label: "Georgia", value: { "countryCode:": "ge", currencyCode: "gel" } },
	{
		label: "French Guiana",
		value: { "countryCode:": "gf", currencyCode: "eur" }
	},
	{ label: "Guernsey", value: { "countryCode:": "gg", currencyCode: "gbp" } },
	{ label: "Ghana", value: { "countryCode:": "gh", currencyCode: "ghs" } },
	{
		label: "Gibraltar",
		value: { "countryCode:": "gi", currencyCode: "gip" }
	},
	{
		label: "Greenland",
		value: { "countryCode:": "gl", currencyCode: "dkk" }
	},
	{ label: "Gambia", value: { "countryCode:": "gm", currencyCode: "gmd" } },
	{ label: "Guinea", value: { "countryCode:": "gn", currencyCode: "gnf" } },
	{
		label: "Guadeloupe",
		value: { "countryCode:": "gp", currencyCode: "eur" }
	},
	{
		label: "Equatorial Guinea",
		value: { "countryCode:": "gq", currencyCode: "xaf" }
	},
	{ label: "Greece", value: { "countryCode:": "gr", currencyCode: "eur" } },
	{
		label: "South Georgia and the South Sandwich Islands",
		value: { "countryCode:": "gs", currencyCode: "gbp" }
	},
	{
		label: "Guatemala",
		value: { "countryCode:": "gt", currencyCode: "gtq" }
	},
	{ label: "Guam", value: { "countryCode:": "gu", currencyCode: "usd" } },
	{
		label: "Guinea-Bissau",
		value: { "countryCode:": "gw", currencyCode: "xof" }
	},
	{ label: "Guyana", value: { "countryCode:": "gy", currencyCode: "gyd" } },
	{
		label: "Hong Kong",
		value: { "countryCode:": "hk", currencyCode: "hkd" }
	},
	{
		label: "Heard Island and McDonald Islands",
		value: { "countryCode:": "hm", currencyCode: "aud" }
	},
	{ label: "Honduras", value: { "countryCode:": "hn", currencyCode: "hnl" } },
	{ label: "Croatia", value: { "countryCode:": "hr", currencyCode: "hrk" } },
	{ label: "Haiti", value: { "countryCode:": "ht", currencyCode: "htg" } },
	{ label: "Hungary", value: { "countryCode:": "hu", currencyCode: "huf" } },
	{
		label: "Indonesia",
		value: { "countryCode:": "id", currencyCode: "idr" }
	},
	{ label: "Ireland", value: { "countryCode:": "ie", currencyCode: "eur" } },
	{ label: "Israel", value: { "countryCode:": "il", currencyCode: "ils" } },
	{
		label: "Isle of Man",
		value: { "countryCode:": "im", currencyCode: "gbp" }
	},
	{ label: "India", value: { "countryCode:": "in", currencyCode: "inr" } },
	{
		label: "British Indian Ocean Territory",
		value: { "countryCode:": "io", currencyCode: "usd" }
	},
	{ label: "Iraq", value: { "countryCode:": "iq", currencyCode: "iqd" } },
	{ label: "Iran", value: { "countryCode:": "ir", currencyCode: "irr" } },
	{ label: "Iceland", value: { "countryCode:": "is", currencyCode: "isk" } },
	{ label: "Italy", value: { "countryCode:": "it", currencyCode: "eur" } },
	{ label: "Jersey", value: { "countryCode:": "je", currencyCode: "gbp" } },
	{ label: "Jamaica", value: { "countryCode:": "jm", currencyCode: "jmd" } },
	{ label: "Jordan", value: { "countryCode:": "jo", currencyCode: "jod" } },
	{ label: "Japan", value: { "countryCode:": "jp", currencyCode: "jpy" } },
	{ label: "Kenya", value: { "countryCode:": "ke", currencyCode: "kes" } },
	{
		label: "Kyrgyzstan",
		value: { "countryCode:": "kg", currencyCode: "kgs" }
	},
	{ label: "Cambodia", value: { "countryCode:": "kh", currencyCode: "khr" } },
	{ label: "Kiribati", value: { "countryCode:": "ki", currencyCode: "aud" } },
	{ label: "Comoros", value: { "countryCode:": "km", currencyCode: "kmf" } },
	{
		label: "Saint Kitts and Nevis",
		value: { "countryCode:": "kn", currencyCode: "xcd" }
	},
	{
		label: "North Korea",
		value: { "countryCode:": "kp", currencyCode: "kpw" }
	},
	{
		label: "South Korea",
		value: { "countryCode:": "kr", currencyCode: "krw" }
	},
	{ label: "Kuwait", value: { "countryCode:": "kw", currencyCode: "kwd" } },
	{
		label: "Cayman Islands",
		value: { "countryCode:": "ky", currencyCode: "kyd" }
	},
	{
		label: "Kazakhstan",
		value: { "countryCode:": "kz", currencyCode: "kzt" }
	},
	{ label: "Laos", value: { "countryCode:": "la", currencyCode: "lak" } },
	{ label: "Lebanon", value: { "countryCode:": "lb", currencyCode: "lbp" } },
	{
		label: "Saint Lucia",
		value: { "countryCode:": "lc", currencyCode: "xcd" }
	},
	{
		label: "Liechtenstein",
		value: { "countryCode:": "li", currencyCode: "chf" }
	},
	{
		label: "Sri Lanka",
		value: { "countryCode:": "lk", currencyCode: "lkr" }
	},
	{ label: "Liberia", value: { "countryCode:": "lr", currencyCode: "lrd" } },
	{ label: "Lesotho", value: { "countryCode:": "ls", currencyCode: "lsl" } },
	{
		label: "Lithuania",
		value: { "countryCode:": "lt", currencyCode: "eur" }
	},
	{
		label: "Luxembourg",
		value: { "countryCode:": "lu", currencyCode: "eur" }
	},
	{ label: "Latvia", value: { "countryCode:": "lv", currencyCode: "eur" } },
	{ label: "Libya", value: { "countryCode:": "ly", currencyCode: "lyd" } },
	{ label: "Morocco", value: { "countryCode:": "ma", currencyCode: "mad" } },
	{ label: "Monaco", value: { "countryCode:": "mc", currencyCode: "eur" } },
	{ label: "Moldova", value: { "countryCode:": "md", currencyCode: "mdl" } },
	{
		label: "Montenegro",
		value: { "countryCode:": "me", currencyCode: "eur" }
	},
	{
		label: "Saint Martin",
		value: { "countryCode:": "mf", currencyCode: "eur" }
	},
	{
		label: "Madagascar",
		value: { "countryCode:": "mg", currencyCode: "mga" }
	},
	{
		label: "Marshall Islands",
		value: { "countryCode:": "mh", currencyCode: "usd" }
	},
	{
		label: "Macedonia",
		value: { "countryCode:": "mk", currencyCode: "mkd" }
	},
	{ label: "Mali", value: { "countryCode:": "ml", currencyCode: "xof" } },
	{
		label: "Myanmar [Burma]",
		value: { "countryCode:": "mm", currencyCode: "mmk" }
	},
	{ label: "Mongolia", value: { "countryCode:": "mn", currencyCode: "mnt" } },
	{ label: "Macao", value: { "countryCode:": "mo", currencyCode: "mop" } },
	{
		label: "Northern Mariana Islands",
		value: { "countryCode:": "mp", currencyCode: "usd" }
	},
	{
		label: "Martinique",
		value: { "countryCode:": "mq", currencyCode: "eur" }
	},
	{
		label: "Mauritania",
		value: { "countryCode:": "mr", currencyCode: "mro" }
	},
	{
		label: "Montserrat",
		value: { "countryCode:": "ms", currencyCode: "xcd" }
	},
	{ label: "Malta", value: { "countryCode:": "mt", currencyCode: "eur" } },
	{
		label: "Mauritius",
		value: { "countryCode:": "mu", currencyCode: "mur" }
	},
	{ label: "Maldives", value: { "countryCode:": "mv", currencyCode: "mvr" } },
	{ label: "Malawi", value: { "countryCode:": "mw", currencyCode: "mwk" } },
	{ label: "Mexico", value: { "countryCode:": "mx", currencyCode: "mxn" } },
	{ label: "Malaysia", value: { "countryCode:": "my", currencyCode: "myr" } },
	{
		label: "Mozambique",
		value: { "countryCode:": "mz", currencyCode: "mzn" }
	},
	{ label: "Namibia", value: { "countryCode:": "na", currencyCode: "nad" } },
	{
		label: "New Caledonia",
		value: { "countryCode:": "nc", currencyCode: "xpf" }
	},
	{ label: "Niger", value: { "countryCode:": "ne", currencyCode: "xof" } },
	{
		label: "Norfolk Island",
		value: { "countryCode:": "nf", currencyCode: "aud" }
	},
	{ label: "Nigeria", value: { "countryCode:": "ng", currencyCode: "ngn" } },
	{
		label: "Nicaragua",
		value: { "countryCode:": "ni", currencyCode: "nio" }
	},
	{
		label: "Netherlands",
		value: { "countryCode:": "nl", currencyCode: "eur" }
	},
	{ label: "Norway", value: { "countryCode:": "no", currencyCode: "nok" } },
	{ label: "Nepal", value: { "countryCode:": "np", currencyCode: "npr" } },
	{ label: "Nauru", value: { "countryCode:": "nr", currencyCode: "aud" } },
	{ label: "Niue", value: { "countryCode:": "nu", currencyCode: "nzd" } },
	{
		label: "New Zealand",
		value: { "countryCode:": "nz", currencyCode: "nzd" }
	},
	{ label: "Oman", value: { "countryCode:": "om", currencyCode: "omr" } },
	{ label: "Panama", value: { "countryCode:": "pa", currencyCode: "pab" } },
	{ label: "Peru", value: { "countryCode:": "pe", currencyCode: "pen" } },
	{
		label: "French Polynesia",
		value: { "countryCode:": "pf", currencyCode: "xpf" }
	},
	{
		label: "Papua New Guinea",
		value: { "countryCode:": "pg", currencyCode: "pgk" }
	},
	{
		label: "Philippines",
		value: { "countryCode:": "ph", currencyCode: "php" }
	},
	{ label: "Pakistan", value: { "countryCode:": "pk", currencyCode: "pkr" } },
	{ label: "Poland", value: { "countryCode:": "pl", currencyCode: "pln" } },
	{
		label: "Saint Pierre and Miquelon",
		value: { "countryCode:": "pm", currencyCode: "eur" }
	},
	{
		label: "Pitcairn Islands",
		value: { "countryCode:": "pn", currencyCode: "nzd" }
	},
	{
		label: "Puerto Rico",
		value: { "countryCode:": "pr", currencyCode: "usd" }
	},
	{
		label: "Palestine",
		value: { "countryCode:": "ps", currencyCode: "ils" }
	},
	{ label: "Portugal", value: { "countryCode:": "pt", currencyCode: "eur" } },
	{ label: "Palau", value: { "countryCode:": "pw", currencyCode: "usd" } },
	{ label: "Paraguay", value: { "countryCode:": "py", currencyCode: "pyg" } },
	{ label: "Qatar", value: { "countryCode:": "qa", currencyCode: "qar" } },
	{ label: "Réunion", value: { "countryCode:": "re", currencyCode: "eur" } },
	{ label: "Romania", value: { "countryCode:": "ro", currencyCode: "ron" } },
	{ label: "Serbia", value: { "countryCode:": "rs", currencyCode: "rsd" } },
	{ label: "Russia", value: { "countryCode:": "ru", currencyCode: "rub" } },
	{ label: "Rwanda", value: { "countryCode:": "rw", currencyCode: "rwf" } },
	{
		label: "Saudi Arabia",
		value: { "countryCode:": "sa", currencyCode: "sar" }
	},
	{
		label: "Solomon Islands",
		value: { "countryCode:": "sb", currencyCode: "sbd" }
	},
	{
		label: "Seychelles",
		value: { "countryCode:": "sc", currencyCode: "scr" }
	},
	{ label: "Sudan", value: { "countryCode:": "sd", currencyCode: "sdg" } },
	{ label: "Sweden", value: { "countryCode:": "se", currencyCode: "sek" } },
	{
		label: "Singapore",
		value: { "countryCode:": "sg", currencyCode: "sgd" }
	},
	{
		label: "Saint Helena",
		value: { "countryCode:": "sh", currencyCode: "shp" }
	},
	{ label: "Slovenia", value: { "countryCode:": "si", currencyCode: "eur" } },
	{
		label: "Svalbard and Jan Mayen",
		value: { "countryCode:": "sj", currencyCode: "nok" }
	},
	{ label: "Slovakia", value: { "countryCode:": "sk", currencyCode: "eur" } },
	{
		label: "Sierra Leone",
		value: { "countryCode:": "sl", currencyCode: "sll" }
	},
	{
		label: "San Marino",
		value: { "countryCode:": "sm", currencyCode: "eur" }
	},
	{ label: "Senegal", value: { "countryCode:": "sn", currencyCode: "xof" } },
	{ label: "Somalia", value: { "countryCode:": "so", currencyCode: "sos" } },
	{ label: "Suriname", value: { "countryCode:": "sr", currencyCode: "srd" } },
	{
		label: "South Sudan",
		value: { "countryCode:": "ss", currencyCode: "ssp" }
	},
	{
		label: "São Tomé and Príncipe",
		value: { "countryCode:": "st", currencyCode: "std" }
	},
	{
		label: "El Salvador",
		value: { "countryCode:": "sv", currencyCode: "usd" }
	},
	{
		label: "Sint Maarten",
		value: { "countryCode:": "sx", currencyCode: "ang" }
	},
	{ label: "Syria", value: { "countryCode:": "sy", currencyCode: "syp" } },
	{
		label: "Swaziland",
		value: { "countryCode:": "sz", currencyCode: "szl" }
	},
	{
		label: "Turks and Caicos Islands",
		value: { "countryCode:": "tc", currencyCode: "usd" }
	},
	{ label: "Chad", value: { "countryCode:": "td", currencyCode: "xaf" } },
	{
		label: "French Southern Territories",
		value: { "countryCode:": "tf", currencyCode: "eur" }
	},
	{ label: "Togo", value: { "countryCode:": "tg", currencyCode: "xof" } },
	{ label: "Thailand", value: { "countryCode:": "th", currencyCode: "thb" } },
	{
		label: "Tajikistan",
		value: { "countryCode:": "tj", currencyCode: "tjs" }
	},
	{ label: "Tokelau", value: { "countryCode:": "tk", currencyCode: "nzd" } },
	{
		label: "East Timor",
		value: { "countryCode:": "tl", currencyCode: "usd" }
	},
	{
		label: "Turkmenistan",
		value: { "countryCode:": "tm", currencyCode: "tmt" }
	},
	{ label: "Tunisia", value: { "countryCode:": "tn", currencyCode: "tnd" } },
	{ label: "Tonga", value: { "countryCode:": "to", currencyCode: "top" } },
	{ label: "Turkey", value: { "countryCode:": "tr", currencyCode: "try" } },
	{
		label: "Trinidad and Tobago",
		value: { "countryCode:": "tt", currencyCode: "ttd" }
	},
	{ label: "Tuvalu", value: { "countryCode:": "tv", currencyCode: "aud" } },
	{ label: "Taiwan", value: { "countryCode:": "tw", currencyCode: "twd" } },
	{ label: "Tanzania", value: { "countryCode:": "tz", currencyCode: "tzs" } },
	{ label: "Ukraine", value: { "countryCode:": "ua", currencyCode: "uah" } },
	{ label: "Uganda", value: { "countryCode:": "ug", currencyCode: "ugx" } },
	{
		label: "U.S. Minor Outlying Islands",
		value: { "countryCode:": "um", currencyCode: "usd" }
	},
	{
		label: "United States",
		value: { "countryCode:": "us", currencyCode: "usd" }
	},
	{ label: "Uruguay", value: { "countryCode:": "uy", currencyCode: "uyu" } },
	{
		label: "Uzbekistan",
		value: { "countryCode:": "uz", currencyCode: "uzs" }
	},
	{
		label: "Vatican City",
		value: { "countryCode:": "va", currencyCode: "eur" }
	},
	{
		label: "Saint Vincent and the Grenadines",
		value: { "countryCode:": "vc", currencyCode: "xcd" }
	},
	{
		label: "Venezuela",
		value: { "countryCode:": "ve", currencyCode: "vef" }
	},
	{
		label: "British Virgin Islands",
		value: { "countryCode:": "vg", currencyCode: "usd" }
	},
	{
		label: "U.S. Virgin Islands",
		value: { "countryCode:": "vi", currencyCode: "usd" }
	},
	{ label: "Vietnam", value: { "countryCode:": "vn", currencyCode: "vnd" } },
	{ label: "Vanuatu", value: { "countryCode:": "vu", currencyCode: "vuv" } },
	{
		label: "Wallis and Futuna",
		value: { "countryCode:": "wf", currencyCode: "xpf" }
	},
	{ label: "Samoa", value: { "countryCode:": "ws", currencyCode: "wst" } },
	{ label: "Kosovo", value: { "countryCode:": "xk", currencyCode: "eur" } },
	{ label: "Yemen", value: { "countryCode:": "ye", currencyCode: "yer" } },
	{ label: "Mayotte", value: { "countryCode:": "yt", currencyCode: "eur" } },
	{
		label: "South Africa",
		value: { "countryCode:": "za", currencyCode: "zar" }
	},
	{ label: "Zambia", value: { "countryCode:": "zm", currencyCode: "zmw" } },
	{ label: "Zimbabwe", value: { "countryCode:": "zw", currencyCode: "zwl" } }
];

export function stripeUnitPrice(currency, amount) {
	if(ZERO_DECIMAL_CURRENCIES.includes(currency)) {
		return amount;
	} else {
		return amount * 100;
	}
}

export function getNativePrice(currency, amount, term) {
	let total_amount = amount * CURRENCY_RATES[currency];
	let return_amount = 0; 
	let one_decimal_price = 0;
	if(term === 'month') {
		let fraction = total_amount - Math.floor(total_amount);
		let fraction_amount_inr = fraction * 100 * (CURRENCY_RATES[currency]/CURRENCY_RATES['inr'])
		if (fraction_amount_inr >= 1) {
			return_amount = Math.round(total_amount);
		} else {
			return_amount = Math.round((total_amount + Number.EPSILON) * 10) / 10;
		}
	} else if(term === 'year') {
		let monthly_amount = total_amount / 12;
		let fraction = monthly_amount - Math.floor(monthly_amount);
		let fraction_amount_inr = fraction * 100 * (CURRENCY_RATES[currency]/CURRENCY_RATES['inr']);
		if(fraction_amount_inr >= 1) {
			return_amount = Math.round(monthly_amount) * 12;
		} else {
			let one_decimal_price = Math.round((monthly_amount + Number.EPSILON) * 10) / 10;
			return_amount = one_decimal_price * 12;
		}
	}

	if(ZERO_DECIMAL_CURRENCIES.includes(currency)) {
		return Math.round(return_amount);
	} else {
		return return_amount 
	}
}

